import styled from 'styled-components'

export const CatalogItemDetailsHeaderStyled = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  min-height: ${(props) => props.theme.typography.pxToRem(40)};
  padding: ${(props) => props.theme.space.small}
    ${(props) => props.theme.space.medium};

  button {
    min-width: auto;
    min-height: auto;
    padding: 0;
  }
`
